import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Flex,
  HStack,
  Input,
  Select,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Badge,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';
import axiosInstance from '../../../api/AxiosInstance';
import FormularioPrograma from './FormularioPrograma';
import ModalAsignaciones from './ModalAsignaciones';

const TablaProgramas: React.FC = () => {
  const { isOpen: isOpenVer, onOpen: onOpenVer, onClose: onCloseVer } = useDisclosure();
  const { isOpen: isOpenEditar, onOpen: onOpenEditar, onClose: onCloseEditar } = useDisclosure();
  const { isOpen: isOpenNuevo, onOpen: onOpenNuevo, onClose: onCloseNuevo } = useDisclosure();
  const { isOpen: isOpenAsignaciones, onOpen: onOpenAsignaciones, onClose: onCloseAsignaciones } = useDisclosure();

  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [data, setData] = useState<any[]>([]);
  const [cargando, setCargando] = useState(false);
  const [filtroEstatus, setFiltroEstatus] = useState('');
  const [filtroEjercicio, setFiltroEjercicio] = useState('');

  const fetchData = async () => {
    setCargando(true);
    try {
      const params = new URLSearchParams();
      if (filtroEstatus) params.append('estatus', filtroEstatus);
      if (filtroEjercicio) params.append('ejercicioFiscal', filtroEjercicio);
      const res = await axiosInstance.get(`/desarrollo-social/programas?${params.toString()}`);
      setData(res.data || []);
    } catch {
      setData([]);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleVer = async (item: any) => {
    try {
      const res = await axiosInstance.get(`/desarrollo-social/programas/${item.id}`);
      setSelectedItem(res.data);
    } catch {
      setSelectedItem(item);
    }
    onOpenVer();
  };

  const handleEditar = (item: any) => { setSelectedItem(item); onOpenEditar(); };

  const handleAsignaciones = async (item: any) => {
    try {
      const res = await axiosInstance.get(`/desarrollo-social/programas/${item.id}`);
      setSelectedItem(res.data);
    } catch {
      setSelectedItem(item);
    }
    onOpenAsignaciones();
  };

  const handleGuardado = () => { onCloseNuevo(); onCloseEditar(); fetchData(); };

  return (
    <Box>
      <Flex mb={4} justify="space-between" align="center" flexWrap="wrap" gap={3}>
        <HStack spacing={3} flexWrap="wrap">
          <Select placeholder="Estatus" value={filtroEstatus} onChange={(e) => setFiltroEstatus(e.target.value)} size="sm" w="160px">
            <option value="activo">Activo</option>
            <option value="inactivo">Inactivo</option>
          </Select>
          <Input
            placeholder="Ejercicio fiscal"
            value={filtroEjercicio}
            onChange={(e) => setFiltroEjercicio(e.target.value)}
            size="sm"
            w={{ base: 'full', md: '180px' }}
          />
          <Button size="sm" onClick={fetchData} variant="outline">Filtrar</Button>
        </HStack>
        <Button size="sm" leftIcon={<AddIcon />} bg="#5b182b" color="white" _hover={{ bg: '#691f30' }} onClick={onOpenNuevo}>
          Nuevo programa
        </Button>
      </Flex>

      <Box overflowX="auto" borderRadius="md" boxShadow="md" bg="white">
        <Table variant="simple" size="sm">
          <Thead bg="#5b182b">
            <Tr>
              <Th color="white" fontSize="xs">Nombre</Th>
              <Th color="white" fontSize="xs">Tipo</Th>
              <Th color="white" fontSize="xs">Ejercicio</Th>
              <Th color="white" fontSize="xs">Meta</Th>
              <Th color="white" fontSize="xs">Estatus</Th>
              <Th color="white" fontSize="xs">Acciones</Th>
            </Tr>
          </Thead>
          <Tbody>
            {cargando ? (
              <Tr><Td colSpan={6} textAlign="center" py={8}><Text color="gray.500">Cargando...</Text></Td></Tr>
            ) : data.length === 0 ? (
              <Tr><Td colSpan={6} textAlign="center" py={8}><Text color="gray.400">Sin registros</Text></Td></Tr>
            ) : (
              data.map((item, idx) => (
                <Tr key={item.id} bg={idx % 2 === 0 ? 'white' : 'gray.50'} _hover={{ bg: 'gray.100' }}>
                  <Td maxW="240px"><Text noOfLines={1} title={item.nombre}>{item.nombre}</Text></Td>
                  <Td>{item.tipo}</Td>
                  <Td>{item.ejercicioFiscal}</Td>
                  <Td>{item.metaProgramada}</Td>
                  <Td><Badge colorScheme={item.estatus === 'activo' ? 'green' : 'gray'}>{item.estatus}</Badge></Td>
                  <Td>
                    <HStack spacing={1}>
                      <Button size="xs" colorScheme="blue" variant="outline" onClick={() => handleVer(item)}>Ver</Button>
                      <Button size="xs" colorScheme="orange" variant="outline" onClick={() => handleEditar(item)}>Editar</Button>
                      <Button size="xs" colorScheme="teal" variant="outline" onClick={() => handleAsignaciones(item)}>Asignaciones</Button>
                    </HStack>
                  </Td>
                </Tr>
              ))
            )}
          </Tbody>
        </Table>
      </Box>

      <Modal isOpen={isOpenVer} onClose={onCloseVer} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="xl" overflow="hidden">
          <ModalHeader borderBottom="1px solid" borderColor="gray.200" color="#5b182b" bg="gray.50">Detalle del programa</ModalHeader>
          <ModalBody py={5} bg="white">
            {selectedItem && <FormularioPrograma modo="view" data={selectedItem} />}
          </ModalBody>
          <ModalFooter borderTop="1px solid" borderColor="gray.100" bg="gray.50">
            <Button onClick={onCloseVer}>Cerrar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenEditar} onClose={onCloseEditar} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="xl" overflow="hidden">
          <ModalHeader borderBottom="1px solid" borderColor="gray.200" color="#5b182b" bg="gray.50">Editar programa</ModalHeader>
          <ModalBody py={5} bg="white">
            {selectedItem && <FormularioPrograma modo="edit" data={selectedItem} onGuardado={handleGuardado} onCancelar={onCloseEditar} />}
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenNuevo} onClose={onCloseNuevo} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="xl" overflow="hidden">
          <ModalHeader borderBottom="1px solid" borderColor="gray.200" color="#5b182b" bg="gray.50">Nuevo programa</ModalHeader>
          <ModalBody py={5} bg="white">
            <FormularioPrograma modo="new" onGuardado={handleGuardado} onCancelar={onCloseNuevo} />
          </ModalBody>
        </ModalContent>
      </Modal>

      {selectedItem && (
        <ModalAsignaciones
          isOpen={isOpenAsignaciones}
          onClose={onCloseAsignaciones}
          programa={selectedItem}
        />
      )}
    </Box>
  );
};

export default TablaProgramas;


